export default "__VITE_ASSET__Bfw65skT__"